import * as React from 'react';
import * as className from 'classnames';
import {StatelessComponent} from 'react';
import {AuthTooltip as Tooltip} from '../tooltip/tooltip';
import {Loader} from '../../loader/loader';
import './styles.sass';

export interface IButtonProps {
  tooltipDisabled?: boolean;
  tooltipLabel?: string;
  isLoading?: boolean;
  disabled?: boolean;
  children?: any;
  color?: 'violet' | 'genoa-viridian';
  label?: string;
  error?: string;
  type?: 'button' | 'submit' | 'reset';
  onClick?: () => void;
}

export const AuthButton: StatelessComponent<IButtonProps> = ({
  tooltipDisabled,
  tooltipLabel,
  isLoading,
  disabled,
  children,
  label,
  error,
  color,
  type,
  onClick,
}: IButtonProps) => (
  <div className={'auth-button'}>
    <Tooltip label={tooltipLabel} disabled={tooltipDisabled || !tooltipLabel}>
      <button
        className={className('btn btn_lg', {[`btn_${color}`]: color})}
        disabled={disabled}
        type={type || 'button'}
        onClick={onClick}
      >
        {isLoading ? <Loader white inline /> : children || label || 'Continue'}
      </button>
    </Tooltip>

    {error && (
      <div className={'auth-button__error'}>{error}</div>
    )}
  </div>
);

AuthButton.defaultProps = {
  color: 'genoa-viridian',
};
